import React from "react";
import { scoreStyle } from "./MemberSignalMetrics";
import "./SignalScoreGauge.css";

// Same center, radius and 250-degree sweep as WPF Controls/SignalScoreGauge.
function arc(sweep) {
  const point = angle => {
    const radians = angle * Math.PI / 180;
    return `${47.3 + 34.6 * Math.cos(radians)} ${51 + 34.6 * Math.sin(radians)}`;
  };
  return `M ${point(145)} A 34.6 34.6 0 ${sweep > 180 ? 1 : 0} 1 ${point(145 + sweep)}`;
}

export default function SignalScoreGauge({ score }) {
  if (!Number.isFinite(score)) return <>Unavailable</>;
  const value = Math.max(0, Math.min(100, score));
  const band = scoreStyle(value);
  const status = band[0].toUpperCase() + band.slice(1);
  return <svg className={`dashboard-score-gauge team-signal-score--${band}`} viewBox="0 0 95 82"
    role="img" aria-label={`Signal Score: ${value}%, ${status}`} focusable="false">
    <path className="dashboard-score-gauge-track" d={arc(250)} />
    {value > 0 && <path className="dashboard-score-gauge-arc" d={arc(250 * value / 100)} />}
    <text className="dashboard-score-gauge-value" x="47.3" y="49" textAnchor="middle">{value}%</text>
    <text className="dashboard-score-gauge-status" x="47.3" y="63" textAnchor="middle">{status}</text>
  </svg>;
}
